"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rectangle = void 0;
const Point_1 = require("./Point");
const Rotation_1 = require("./Rotation");
class Rectangle {
    static createFromEagle(rect, parent) {
        let p = new Point_1.Point(rect._attributes.x1, rect._attributes.y1);
        let width = parseFloat(rect._attributes.x2) - parseFloat(rect._attributes.x1);
        let height = parseFloat(rect._attributes.y2) - parseFloat(rect._attributes.y1);
        if (parent) {
            p = p.rotate(parent.rotation);
            p.add(parent.point);
            if ([Rotation_1.Rotation.R90, Rotation_1.Rotation.R270].includes(parent.rotation)) {
                let temp = width;
                width = height;
                height = temp;
            }
        }
        return new Rectangle(p.x, p.y, width, height, parseInt(rect._attributes.layer));
    }
    constructor(x, y, width, height, layer) {
        this.point = new Point_1.Point(x, y);
        this.width = width;
        this.height = height;
        this.layer = layer;
    }
}
exports.Rectangle = Rectangle;
//# sourceMappingURL=Rectangle.js.map